import {bindable} from "aurelia-framework";

export class VideoReferenceInput
{
    @bindable field;
    @bindable({defaultBindingMode: 2}) value;
}
